<template>
	<div class="table">
		<el-table
			border
			ref="multipleTable"
			:data="tableData"
			:header-cell-style="{ 'text-align': 'center' }"
			:cell-style="{ 'text-align': 'center' }"
			tooltip-effect="dark"
			style="width: 100%"
			height="60vh"
			@selection-change="handleSelectionChange"
		>
			<el-table-column type="selection" width="55"> </el-table-column>

			<el-table-column prop="id" label="序号" width="120"> </el-table-column>
			<el-table-column prop="name" label="角色名称"> </el-table-column>

			<el-table-column prop="desc" label="描述"> </el-table-column>

			<el-table-column fixed="right" label="操作" width="200">
				<template slot-scope="scope">
					<span class="pointer" @click="delRoles(scope.row)">删除</span>
					<span class="pointer margin_left_10" @click="detail(scope.row)"
						>编辑</span
					>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
import { authLists, delRoles } from "@/api/limitsauthority";
export default {
	props: ["tableData"],
	name: "",
	data() {
		return {
			stateObj: {
				id: "",
				rules: "",
				menus: "",
				checkList: [],
			},

			dialog: false,
			value: true,
		};
	},
	created() {},
	methods: {
		detail(row) {
			this.$router.push({
				path: "/limitsauthority/addrole",
				query: { id: row.id },
			});
		},

		delRoles(row) {
			delRoles({
				id: row.id,
			})
				.then((res) => {
					if (res.code == 200) {
						this.$parent.$parent.getDataList();
					} else {
					}
					this.loading = false;
				})
				.catch((error) => {
					this.$message.error(error.message);
				});
		},
		getDataList(row) {
			authLists({
				account_id: this.$store.state.user.user.id,
				id: row.id,
				mark: "account",
			})
				.then((res) => {
					if (res.code == 200) {
					} else {
					}
					this.loading = false;
				})
				.catch((error) => {
					this.$message.error(error.message);
				});
		},
		toggleSelection(rows) {
			if (rows) {
				rows.forEach((row) => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
	},
};
</script>

<style scoped></style>
